import React, {Component} from 'react';
import {connect} from 'react-redux';

class InputPassword extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mostrarPasswordchecked: false,
        };


        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.onMostrarPassword = this.onMostrarPassword.bind(this);
    }

    handleChange(event) {
        if (this.props.configInput.type === "checkbox") {
            this.props.configInput.methodChange(event.target.checked, event.target.id);
        } else {
            this.props.configInput.methodChange(event.target.value, event.target.id);
        }
    }

    handleBlur(event) {
        if (this.props.configInput.hasOwnProperty("blurMethod")) {
            this.props.configInput.blurMethod(this.props.configInput.id);
        }
    }

    onMostrarPassword(value) {
        const {target: {checked}} = value;
        this.setState({
            mostrarPasswordchecked: checked
        })
    }


    render() {
        let formControl = "form-control " + this.props.configInput.controlValidate;
        let iconSpan = "" + this.props.configInput.iconSpan;
        let formGroup = "form-group ";
        if (this.props.configInput.type === "checkbox") {
            formGroup = formGroup + " " + this.props.configInput.formGroup;
        }

        const cssColumns = this.props.configInput.columns
        const numColumns = parseInt(cssColumns.replace("col-lg-", ""));
        const columnsInput = Math.ceil(numColumns * 0.7);
        const columnsCheckbox = numColumns - columnsInput;

        return (
            <div className={"row password-input-group " + this.props.configInput.columns}>
                <div className={"col-lg-" + columnsInput} style={{width: "70%"}}>
                    <div className={formGroup}>
                        {this.props.configInput.title && <span>{this.props.configInput.title}</span>}
                        <div className={this.props.configInput.inlineIcon}>
                            <input id={this.props.configInput.id} name={this.props.configInput.id}
                                   type={(this.state.mostrarPasswordchecked) ? "text" : "password"}
                                   className={formControl}
                                   placeholder={this.props.configInput.placeHolder} onChange={this.handleChange}
                                   onBlur={this.handleBlur}/>
                            <span className={iconSpan}></span>
                        </div>


                    </div>
                </div>
                <label className={"col-lg-" + columnsCheckbox} style={{width: "30%", marginTop: "0.7rem"}}>
                    <input id="ocultarPassword" name="ocultarPassword" type="checkbox"
                           className="form-control form-check-input" onChange={this.onMostrarPassword}/>
                    {/*<span className="icon-registro-checkbox las la-eye-slash"></span>*/}
                    <span className="custom-control-description"> Mostrar</span>
                </label>
            </div>
        );
    }

    // this.configOcultar_dir_exacta = {
    //     controlValidate: "form-check-input",
    //     iconSpan: "icon-registro-checkbox las la-eye-slash",
    //     columns: "col-lg-12",
    //     id: "ocultarDirExacta",
    //     type: "checkbox",
    //     formGroup: "d-flex align-items-center justify-content-between",
    //     labelClass: "custom-control custom-checkbox",
    //     indicator: "custom-control-indicator",
    //     descriptionClass: "custom-control-description",
    //     labelDescription: " No mostrar dirección exacta públicamente",
    //     methodChange: this.changeOcultarDireccionExacta.bind(this)
    // };


    componentDidMount() {
        let element = $("#" + this.props.configInput.id);
        if (this.props.configInput.hasOwnProperty("readOnly")) {
            element.attr('readonly', this.props.configInput.readOnly);
        }

        if (this.props.configInput.hasOwnProperty("maxlength")) {
            element.attr('maxlength', this.props.configInput.maxlength);
        }

        if (this.props.configInput.hasOwnProperty("numericKeyPress")) {
            $("#" + this.props.configInput.id).on("keypress keyup", (event) => {
                let element = $(event.currentTarget);
                element.val(element.val().replace(/[^\d].+/, ""));
                if ((event.which < 48 || event.which > 57)) {
                    event.preventDefault();
                }
            })
        }
        if (this.props.hasOwnProperty("initialText")) {
            element.val(this.props.initialText);
        }
        if (this.props.configInput.type === "checkbox") {
            element.prop('checked', this.props.initialText);
        }
    }

    componentDidUpdate() {
        let element = $("#" + this.props.configInput.id);
        if (this.props.hasOwnProperty("initialText")) {
            element.val(this.props.initialText);
        }

    }

}

function mapStateToProps(state) {
    return {}
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default InputPassword
